module.exports = __webpack_public_path__ + "img/SketchPng219f67e0bc026910b53f0323756095007b4c2c9c60849d43cca57e9b69e3362b.259d050a.png";